import { connectMediaStore, useMMDispatchActions } from './withOwnReduxStore';
import { initMediaPopup, InitMediaPopupPayload } from '../actions';
import { normalizeDeviation, normalizeGallection } from '../../redux/normalizr/helpers';

export type WithMediaPopupInitProps = {
  initMediaPopup: (payload: InitMediaPopupPayload) => any;
};

const mapDispatchToProps = dispatch => ({
  initMediaPopup: (payload: InitMediaPopupPayload) => {
    const { gallectionFolder, tier } = payload;
    let entities: any;
    if (gallectionFolder) {
      entities = normalizeGallection(gallectionFolder);
    } else if (tier) {
      entities = normalizeDeviation(tier);
    }

    dispatch(
      initMediaPopup({
        ...payload,
        entities,
      })
    );
  },
});

export const useMediaPopupInit = (): WithMediaPopupInitProps => ({
  ...useMMDispatchActions({
    initMediaPopup: (payload: InitMediaPopupPayload) => {
      const { gallectionFolder, tier } = payload;
      let entities: any;
      if (gallectionFolder) {
        entities = normalizeGallection(gallectionFolder);
      } else if (tier) {
        entities = normalizeDeviation(tier);
      }

      return initMediaPopup({
        ...payload,
        entities,
      });
    },
  }),
});

export default connectMediaStore(null, mapDispatchToProps);
